import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from 'store/newDocumentStore';

import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';

import Background from '../components/Background';

const BackgroundContainer = ({ edit, create }) => (
  <DocumentLoader names={['msBackground']}>
    <DocumentProvider>
      <Background onStartEdit={edit} onCreate={create} />
    </DocumentProvider>
  </DocumentLoader>
);

BackgroundContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(
  BackgroundContainer,
);
